import backgroundImg from "@assets/valorant-hero-background.png";
import SSBackgroundImage, {
  type IBackgroundImageProps,
} from "@core-components/backgroundImage/BackgroundImage";

const ValorantBackgroundImage: React.FC<IBackgroundImageProps> = (props) => {
  return <SSBackgroundImage background={backgroundImg} {...props} />;
};

export default ValorantBackgroundImage;
